import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

class ProductSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title} style={{ color: "#4BB64B" }}>WHAT WE DO</h2>
            <br/>
            <h4 className={classes.description}>
              We are the leading consulting firm in Indonesia focusing on quality management services. We work with change-oriented executives to help them make better decisions, convert those decisions to actions and deliver the sustainable success they desire.
            </h4>
            <br />
            <h4 className={classes.description}>
              Our unique approach is tailored and comparable to traditional change management that helps clients to measure and manage risk while increasing agility and maintaining sustainability at once.
            </h4>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/AboutPage/Sections/ProductSection.jsx